<template>
  <div class="v-content">
    <v-footer color="secondary" :fixed="fixed" app>
      <v-layout row wrap justify-space-between align-center>
        <v-flex xs3>
          <v-btn @click="dialog = true" small color="pink accent-2 white--text">
              Preguntas Frecuentes
          </v-btn>
        </v-flex>
        <v-flex xs3>
          <span class="white--text">&nbsp;&nbsp;The Columbus School&nbsp;&nbsp; &copy; {{ new Date().getFullYear() }}</span>
        </v-flex>
        <v-flex xs2>
          <a target="_blank" href="https://www.placetopay.com">
            <v-img contain height="30px" :src="`${appUrl}/storage/img/logo_placetopay.svg`"></v-img>
          </a>
        </v-flex>
      </v-layout>
    </v-footer>
    <FaqDialog
      :dialog="dialog"
      v-on:close="dialog = false"
    ></FaqDialog>
  </div>
</template>
<script>
import FaqDialog from './faqs'
export default {
  components: {
    FaqDialog,

  },
  data() {
    return {
      fixed: false,
      dialog: false,
      appUrl: window.config.appUrl
    }
  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/PageFooter.vue